import styled from 'styled-components'
import { Image } from '@sainsburys-tech/bolt'

export const ArgosCard = styled.a`
  cursor: pointer;
  padding: 20px 0 30px;
  display: block;
`
export const ArgosCardImage = styled(Image)`
  width: 100%;
  overflow: hidden;
  max-height: 240px;

  @media (min-width: ${(props) => props.theme.screen_md_min}) {
    max-height: 200px;
  }
`
